import sc from 'styled-components';
import {Layout, UnifonTheme} from '@phonectas/unifon-ui-kit';

export const DashboardStyled = sc(Layout)<{theme: UnifonTheme}>`
	padding: ${({theme}) => theme.spacing(0, 5)};
`;
